import "./TaskSpotLight.css"
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable"
import { useDroppable } from "@dnd-kit/core"
import { Task } from "../Task/Task"
import { Pending } from "../Pending/Pending"
import { Finish } from "../Finish/Finish"

function TaskSpotLight({ task, onDeleteTask }) {

  const todo = task.filter(e => e.status === "todo")
  const pending = task.filter(e => e.status === "pending")
  const finish = task.filter(e => e.status === "finish")

  const { setNodeRef: todoRef, isOver: isTodoOver } = useDroppable({ id: "todo", data: { status: "todo"} })
  const { setNodeRef: pendingRef, isOver: isPendingOver } = useDroppable({ id: "pending", data: { status: "pending"} })
  const { setNodeRef: finishRef, isOver: isFinishOver } = useDroppable({ id: "finish", data: { status: "finish"} })

  return (
    <div className="taskSpotLight">

      <div ref={todoRef} className={`column todo-column ${isTodoOver ? "over" : ""}`}>
        <h1>To do</h1>
        <SortableContext
          items={todo.map(t => t.id)}
          strategy={verticalListSortingStrategy}
        >
          {todo.map(task => (
            <Task key={task.id} id={task.id} title={task.title} codeLanguage={task.codeLanguage} status={task.status} onDelete={onDeleteTask} />
          ))}
        </SortableContext>
      </div>

      <div ref={pendingRef} className={`column pending-column ${isPendingOver ? "over": "" }`}>
        <h1>Pending</h1>
        <SortableContext
          items={pending.map(t => t.id)}
          strategy={verticalListSortingStrategy}
        >
          {pending.map(task => (
            <Pending key={task.id} {...task} onDelete={onDeleteTask} />
          ))}
        </SortableContext>
      </div>

      <div ref={finishRef} className={`column finish-column ${isFinishOver ? "over" : ""}`}>
        <h1>Finish</h1>
        <SortableContext
          items={finish.map(t => t.id)}
          strategy={verticalListSortingStrategy}
        >
          {finish.map(task => (
            <Finish key={task.id} {...task} onDelete={onDeleteTask} />
          ))}
        </SortableContext>
      </div>

    </div>
  )
}

export default TaskSpotLight
